module.exports = __webpack_public_path__ + "media/images/icons/share-3be86f01b9ff4e07eed89ed0681d8911.svg";